module.exports = __webpack_public_path__ + "img/millfields_rd_b11.21d961f3.jpg";